import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';

function getProviders({
  offeringType,
  isUngatedForUnifiedSearch = false
}) {
  if (isUngatedForUnifiedSearch) {
    return ecosystemClient.getUnifiedProviders(offeringType);
  }

  return ecosystemClient.getProviders(Array.isArray(offeringType) ? offeringType[0] : offeringType);
}

export const GET_PROVIDERS = registerQuery({
  fieldName: 'providers',
  args: ['offeringType'],
  fetcher: getProviders
});